export const REDIRECT_ETIQA_URL = 'https://www.etiqa.com.my';

export const SCREENSIZE_BREAKPOINT = 576;

export const PROD_HOST = 'edp';
export const UAT_HOST = 'blueberry';
export const UAT_GTM = 'KMCCW2H';
export const PROD_GTM = 'PDHNZCV';

export const TAKAFUL = 'takaful';
export const INSURANCE = 'insurance';
export const EGIB_FULL = 'Etiqa General Insurance Berhad';
export const EGTB_FULL = 'Etiqa General Takaful Berhad';
export const MALAYSIA = 'malaysia';

export const AMLA_CODE_PREFIX = ['APPAMLA', 'AML', 'TRN', 'IBMDM'];
export const SCREENING_CODE_PREFIX = 'QTN';
export const UNDERWRITING_CODE_PREFIX = 'UW';

export const FAIL_TO_VALIDATE_CLIENT = 'QTN001';
export const CLIENT_IS_BLACKLISTED = 'QTN002';
export const FAIL_TO_VALIDATE_SANCTIONED_COUNTRY = 'QTN003';
export const CLIENT_IS_FROM_SANCTIONED_COUNTRY = 'QTN004';
export const CONFLICT_POLICY_ENTITY = 'QTN005';
export const NULL_STATE = 'QTN006';
export const COMMERCIAL_CAR = 'UW0050';
export const ERROR_SANCTION_COUNTRY = 'UW0002';

export const MIN_AGE = 18;
export const MAX_AGE = 70;

export const PF_NUMBER_LENGTH = 8;
export const PAGE_QUOTATION = 'quotation';
export const EGTB = 'EGTB';
export const EGIB = 'EGIB';

export const SOURCEAPP_ECHANNEL = 1;
